import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Info, Loader2 } from "lucide-react";
import { vendorsApi } from "@/lib/api";

export function VendorCustomersTab({ vendorId, onCount }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    vendorsApi.customers(vendorId).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [vendorId]);
  useEffect(() => { if (rows) onCount?.(rows.length); }, [rows, onCount]);

  if (!rows) return <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>;
  return (
    <div className="space-y-3" data-testid="vendor-customers-list">
      <p className="text-sm text-muted-foreground flex items-center gap-2"><Info className="w-4 h-4" />Die Zuordnung erfolgt in der Kundenansicht über die Karte „Arztsoftware“ oder über verknüpfte „Systeme“.</p>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground py-8 text-center" data-testid="vendor-customers-empty">Noch keine Praxis nutzt diese Software.</p>
      ) : (
        <Card>
          <CardContent className="p-0 divide-y">
            {rows.map((c) => (
              <Link key={c.id} to={`/customers/${c.id}`} className="flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors" data-testid={`vendor-customer-${c.id}`}>
                <Building2 className="w-4 h-4 text-muted-foreground shrink-0" />
                <span className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center sm:gap-3">
                  <span className="font-medium sm:flex-1 min-w-0 truncate">{c.company_name}</span>
                  <span className="text-sm text-muted-foreground hidden sm:block">{[c.postal_code, c.city].filter(Boolean).join(" ") || "—"}</span>
                  <span className="text-sm text-muted-foreground break-words sm:max-w-[45%] sm:truncate sm:text-right">{c.contact_name ? `Ansprechpartner: ${c.contact_name}` : "Kein Ansprechpartner"}</span>
                  <span className="flex flex-wrap gap-1 sm:justify-end" data-testid={`vendor-customer-sources-${c.id}`}>
                    {(c.sources || []).map((s) => <Badge key={s} variant="secondary" className="text-[11px] font-normal">{s === "Arztsoftware" ? "Arztsoftware" : `System: ${s}`}</Badge>)}
                  </span>
                </span>
              </Link>
            ))}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
